const about = [
  {
    title: 'Software Engineer',
    place: 'Atlassian. Sydney, Australia',
    description: 'Frontend developer, working in the Jira Ecosystem creating and improving solutions around the subproduct "Advanced Roadmaps".',
    date: '2020 - present',
    type: 'work',
    contentStyle: { background: 'rgb(33, 150, 243)', color: '#fff' },
    contentArrowStyle: { borderRight: '7px solid  rgb(33, 150, 243)' },
    iconStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }
  },
  {
    title: 'AWS Certified Solutions Architect – Associate',
    place: 'Sydney, Australia',
    description: 'Intended for individuals who perform a solutions architect role and have one or more years of hands-on experience designing available, cost-efficient, fault-tolerant, and scalable distributed systems on AWS.',
    date: '2020',
    type: 'study',
    contentStyle: { },
    contentArrowStyle: { },
    iconStyle: { background: 'rgb(233, 30, 99)', color: '#fff' }
  },
  {
    title: 'Software Engineer',
    place: 'Learnosity. Sydney, Australia',
    description: 'Frontend developer. Specialised in accessibility, math, internationalization and the creation of new features for the Assessment stack.',
    date: '2019 - 2020',
    type: 'work',
    contentStyle: { },
    contentArrowStyle: { },
    iconStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }
  },
  {
    title: 'Fifa World Cup Volunteer',
    place: 'Ekaterinburg, Russia',
    description: 'Part of the Media & IT support team at the Media Press building and EKT Arena.',
    date: '2018',
    type: 'volunteer',
    contentStyle: {  },
    contentArrowStyle: {  },
    iconStyle: { background: 'rgb(243, 126, 33)', color: '#fff' }
  },
  {
    title: 'Web Developer',
    place: 'Eyemagnet. Wellington, New Zealand',
    description: 'Full stack web developer, in charge of developing new digital solutions for the company, working closely Analytics and Data Science.',
    date: '2016 - 2019',
    type: 'work',
    contentStyle: { },
    contentArrowStyle: { },
    iconStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }
  },
  {
    title: 'Bachelor in Software Engineering',
    place: 'Universidad Tecnologia Nacional. Cordoba, Argentina',
    description: 'Engineering degree. Thesis: Udar Web Marketing Tools, a software to assist in the digital marketing process.',
    date: '2009 - 2016',
    type: 'study',
    contentStyle: { },
    contentArrowStyle: { },
    iconStyle: { background: 'rgb(233, 30, 99)', color: '#fff' }
  },
  {
    title: 'Web Developer',
    place: 'Globant. Cordoba, Argentina',
    description: 'Frontend Developer, worked in different products for the client Disney Park and Resorts Online.',
    date: '2014 - 2016',
    type: 'work',
    contentStyle: { },
    contentArrowStyle: { },
    iconStyle: { background: 'rgb(33, 150, 243)', color: '#fff'}
  },
  {
    title: 'Full Stack Developer',
    place: 'Netbel. Cordoba, Argentina',
    description: 'Full stack developer, creating the new "Aulica" web app from scratch.',
    date: '2013 - 2014',
    type: 'work',
    contentStyle: { },
    contentArrowStyle: { },
    iconStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }
  }
];

export default about;